import axios, { AxiosResponse } from 'axios'
import { useQuery, UseQueryResult } from 'react-query'
import { SimpleItem, Item } from '../dtos/Selection'
import { BaseAddressDto } from '../dtos'
import { SelectionType, Risk } from '../enums'
import { GenericQueryOptions } from '.'

export const longStaleTime: number = 1000 * 60 * 60 * 24 // 1 den
export const oneHourStaleTime: number = 1000 * 60 * 60 // 1 den
const baseUrl = process.env.PUBLIC_URL
const apiUrl = process.env.REACT_APP_ENUM_API
const url = `${baseUrl}/${apiUrl}`

export enum Enums {
    selection,
    insurer,
    country,
    region,
    risk,
    riskVariant
}

const fetchSelections = (selectionType?: SelectionType) =>
    axios.get<Item[]>(`${url}/GetSelections?type=${selectionType}`)

const fetchInsurers = (addonOnly: boolean | null) =>
    axios.get<Item[]>(`${url}/GetInsurers?addonProviders=${addonOnly}`)

const fetchCountries = () =>
    axios.get<SimpleItem[]>(`${url}/GetCountries`)

const fetchRegions = (postCode: string) =>
    axios.get<BaseAddressDto[]>(`${url}/GetRegions?postCode=${postCode}`)

const fetchYearKm = (categoryId: number) =>
    axios.get<SimpleItem[]>(`${url}/GetYearKm?categoryId=${categoryId}`)

export const useSelections = (selectionType?: SelectionType, options?: GenericQueryOptions<Item[]>): UseQueryResult<AxiosResponse<Item[], any>, any> =>
    useQuery([getEnumName(Enums.selection), selectionType], () => fetchSelections(selectionType), { staleTime: longStaleTime, ...options })

export const useInsurers = (addonOnly: boolean | null, onSuccess: (insuers: Item[]) => void, options?: GenericQueryOptions<Item[]>): UseQueryResult<AxiosResponse<Item[], any>, any> =>
    useQuery([getEnumName(Enums.insurer), addonOnly], () => fetchInsurers(addonOnly), { staleTime: longStaleTime, onSuccess: (e) => onSuccess(e?.data), ...options })

export const useCountries = (enabled?: boolean, options?: GenericQueryOptions<SimpleItem[]>): UseQueryResult<AxiosResponse<SimpleItem[], any>, any> =>
    useQuery(getEnumName(Enums.country), () => fetchCountries(), { staleTime: longStaleTime, enabled, ...options })

export const useRegions = (postCode: string, options?: GenericQueryOptions<BaseAddressDto[]>): UseQueryResult<AxiosResponse<BaseAddressDto[], any>, any> =>
    useQuery([getEnumName(Enums.region), postCode], () => fetchRegions(postCode), { staleTime: longStaleTime, ...options })

export const useGetRisk = (options?: GenericQueryOptions<Item[]>): UseQueryResult<AxiosResponse<Item[], any>, any> =>
    useQuery([getEnumName(Enums.risk)], () => axios.get<Item[]>(`${url}/GetRisks`), { staleTime: longStaleTime, ...options })

export const useGetRiskVariants = (risk?: Risk, options?: GenericQueryOptions<Item[]>): UseQueryResult<AxiosResponse<Item[], any>, any> =>
    useQuery([getEnumName(Enums.riskVariant), risk], () => axios.get<Item[]>(`${url}/GetRiskVariants?riskId=${risk}`), { staleTime: longStaleTime, ...options })

export const useYearKm = (categoryId: number, options?: GenericQueryOptions<SimpleItem[]>): UseQueryResult<AxiosResponse<SimpleItem[], any>, any> =>
    useQuery(['useYearKm', categoryId], () => fetchYearKm(categoryId), { staleTime: longStaleTime, ...options })

export const getEnumName = (enumType: Enums) => Enums[enumType]